import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  GridSimpleReadHLPure,
  ButtonHLPure,
  BoxSomeHeadersGLPure,
  DialogSystemGLPure,
  HeaderHLPure,
  ArrowBtnHLPure,
  TeamChatPure,
} from "../../pures";
import "./followup-new-recruiter.css";
import PdfViewerAction from "../../actions/pdf-viewer/pdf-viewer.action";
import FollowUpConfigurationsView from "../follow-up-actions-contracts/follow-up-actions-contracts-discussion.view";

const FollowUpNewRecruiterView = (props) => {
  const {
    contract,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    createMessage,
    markChatAsRead,
    token,
  } = props;
  const { t } = useTranslation();
  const [filePDF, setFilePDF] = useState({});
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [showDetails, setShowDetails] = useState(false);

  const handleInputChange = (e) => {
    let file = e.target.files[0];
    setFilePDF(file);
    let reader = new FileReader();
    reader.readAsDataURL(file);
  };
  const [selectedDocument, setSelectedDocument] = useState({});
  const [urlPdf, setUrlPdf] = useState(props.documents[0]?.path);
  const [showPdf, setShowPdf] = useState(true);

  const pdfHeight = useMemo(() => {
    const count = props.documents?.length || 0;

    if (count <= 1) return "780px";
    if (count <= 3) return "900px";
    if (count <= 5) return "1100px";

    return "1200px";
  }, [props.documents]);

  const pdf = useMemo(
    () => (
      <PdfViewerAction
        url={urlPdf || props.documents[0]?.path}
        isExtended={true}
        customHeight={pdfHeight}
        isSSRActive={false}
      />
    ),
    [urlPdf, props.documents, pdfHeight]
  );

  useEffect(() => {
    setUrlPdf(props.documents[0]?.path)
  }, [props.documents])

  const handleBtnDiscussion = () => {
    setNameComponentUser("Discusion");
    setShowDetails(true);
  };


  const mobileResolution = useMediaQuery("(max-width:660px)");

  const handleIconBtn = (dataItem) => {
    setUrlPdf(dataItem.path);
    setShowPdf(true);
  };

  return (
    <div className="digitalContractDashboard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <>
          {showLoadingRequesting ? (
            <DialogSystemGLPure
              showLoadingRequesting={showLoadingRequesting}
              toggleLoadingRequesting={toggleLoadingRequesting}
            />
          ) : null}
          {showErrorRequesting ? (
            <DialogSystemGLPure
              showErrorRequesting={showErrorRequesting}
              toggleErrorRequesting={toggleErrorRequesting}
            // messages={messages}
            />
          ) : null}
          {showCompletedRequesting ? (
            <DialogSystemGLPure
              showCompletedRequesting={showCompletedRequesting}
              toggleCompletedRequesting={toggleCompletedRequesting}
            />
          ) : null}

          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            spacing={4}
            className="digitalContractDashboard-container"
          >
            <Grid
              container
              className="digitalContractDashboard-body"
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
            >
              <>
                {/*Header*/}
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                  sm={12}
                  className="digitalContractDashboard-header"
                >
                  <HeaderHLPure
                    subtitleActive={false}
                    title={
                      `${t("followupNewRecruiter.header.title")} / ${props.titleHeader}`
                      // props.workflowButtons.statusCurrent.name
                    }
                  />
                </Grid>

                {showDetails && nameComponentUser ? (
                  <FollowUpConfigurationsView
                    nameComponentUser={nameComponentUser}
                    hideShowDetails={() => {
                      setShowDetails(false);
                      setNameComponentUser("");
                    }}
                    setShowDetails={setShowDetails}
                    setNameComponentUser={setNameComponentUser}
                    // status={status}
                    // setUrlPdf={setUrlPdf}
                    // setQuestionsAnswered={setQuestionsAnswered}
                    {...props}
                    conversation={props.conversation}
                    usersChat={props.usersChat}
                    handleInputChange={handleInputChange}
                    createMessage={createMessage}
                    onMarkAsRead={markChatAsRead}
                  />
                ) : (
                  <>
                    {/*Container primera seccion de items, fila*/}
                    <Grid
                      container
                      lg={12}
                      md={12}
                      xs={12}
                      sm={12}
                      className="followupNewRecruiter-containerBody"
                    >
                      {/*Cards container */}
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <BoxSomeHeadersGLPure
                          titleOne={t("followupNewRecruiter.boxHeader.title1")}
                          titleTwo={t("followupNewRecruiter.boxHeader.title2")}
                          titleThree={"RFC"}
                          titleFour={t("followupNewRecruiter.boxHeader.title4")}
                          subtitleActive={true}
                          subtitleOne={contract.name}
                          subtitleTwo={contract.updatedByUser}
                          subtitleThree={contract.rfc}
                          subtitleFour={props.registerDate}
                        />
                      </Grid>
                      {/*Cards Spinners containers*/}
                      <Grid
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="followupNewRecruiter-containerDetailDocument"
                      >
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="followupNewRecruiter-containerChatGrid"
                        >
                          <Grid
                            item
                            className="followupNewRecruiter-containerGrid"
                          >
                            <GridSimpleReadHLPure
                              dataGrid={props.documents.map(item => item.path === urlPdf ? { ...item, selected: true } : { ...item, selected: false })}
                              skip={0}
                              take={5}
                              titleRow1={t("followupNewRecruiter.grid.generalTitle")}
                              fieldRow1={"documentName"}
                              fieldSubtitle={"registerDate"}
                              textSubtitle={"textSubtitle"}
                              styleCol1={"qrSignedDocument-cellItemStyleCol1"}
                              onSelectedItem={setSelectedDocument}
                              filter={true}
                              fieldImg={"logo"}
                              // handleOnChange={(e, dataItem) =>
                              //   handleOnChangeUpload(e, dataItem)
                              // }
                              column2Status={false}
                              pageableGrid={true}
                              acceptButton={"application/pdf"}
                              btnFileActiveCol2={true}
                              iconArrow={true}
                              iconArrowClick={true}
                              handleIconArrow={(dataItem) =>
                                handleIconBtn(dataItem)
                              }
                              rowClick={true}
                            />
                          </Grid>
                          {!mobileResolution ? (
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <TeamChatPure
                                usersChat={props.usersChat}
                                conversation={props.conversation}
                                membersChat={props.membersChat}
                                handleInputChangeChat={handleInputChange}
                                createMessage={createMessage}
                                onMarkAsRead={markChatAsRead}
                                titleChat={t("followupNewRecruiter.headerChat")}
                                widthChat={1200}
                                heightChat={500}
                                titlePanel={t('newSignatureDetailView.comments.binnacle')}
                              />
                            </Grid>
                          ) : (
                            ""
                          )}
                        </Grid>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className={"followupNewRecruiter-containerPDF"}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className="followupNewRecruiter-pdf"
                          >
                            {pdf}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className={"followupNewRecruiter-containerBtns"}
                    >
                      <Grid className="followupNewRecruiter-button">
                        <ButtonHLPure
                          nameBtn={t("button.exit")}
                          onClickBtn={props.handleBtnGo}
                        />
                      </Grid>
                      <Grid className="followupNewRecruiter-button">
                        <ButtonHLPure
                          nameBtn={props.buttonBack}
                          onClickBtn={props.backBtn}
                        />
                      </Grid>
                      <Grid>
                        <ButtonHLPure
                          primary
                          nameBtn={props.buttonNext}
                          onClickBtn={props.nextBtn}
                        />
                      </Grid>
                      {mobileResolution ? (
                        <div className="">
                          <ArrowBtnHLPure
                            textArrowBtn={t("followupNewRecruiter.grid.arrowBtnText")}
                            primary={true}
                            onClickArrowBtn={(e) => handleBtnDiscussion(e)}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </>
                )}
              </>

              {/*Seccion de fila para footer */}
              <Grid item xs={12} lg={12} md={12} sm={12}>
                <PromotionalFooterPure />
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </div>
  );
};

export default FollowUpNewRecruiterView;
